import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/reverse-triangle.svg'


const _withScopeId = n => (_pushScopeId("data-v-4a5075c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "departure-time-wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "departure-time" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "다른 시간대 보기"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString($props.departureTime), 1 /* TEXT */),
      ($props.hasDifferentTimes)
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" <div class=\"drive-weekday-wrapper\">\n        <div v-if=\"turnInfo.earlyDriveInfos?.length\" class=\"early-drive-info\">\n          <template\n            v-for=\"(earlyDriveInfo, index) in turnInfo.earlyDriveInfos\"\n            :key=\"index\"\n          >\n            <div v-if=\"earlyDriveInfo.weekdayName\" class=\"weekday\">\n              <span>{{ earlyDriveInfo.weekdayName }}</span>\n              <span v-if=\"earlyDriveInfo.earlyMinute\" class=\"early-time\">\n                {{ getEarlyDriveTime(earlyDriveInfo.earlyMinute) }}\n              </span>\n            </div>\n          </template>\n        </div>\n      </div> ")
    ])
  ]))
}